import React from 'react'

import Layout from '@/components/Layout'
import SEO from '@/components/Seo'

import { QsWorldChilenos } from '@/components/Rankings'
import { Content } from '@/components/Rankings/style.css'
import { Columns } from '@/components/Article/style.css'
import Summary from '@/components/Summary'

const IndexPage = () => (
  <Layout>
    <SEO
      title="Ranking QS"
      keywords={[
        `La Tercera`,
        `Ranking QS`,
        `Universidades Chilenas en el extranjero`,
      ]}
    />
    <Content>
      <h1>
        Los 20 campus chilenos en el <strong>QS World</strong>
      </h1>
      <Columns>
        <p>
          Este año, la presencia de universidades chilenas en el ranking QS
          World llegó a una veintena, dos más que en la versión 2021. El
          incremento de planteles ha sido una constante: en 2019 eran 11 las
          casas de estudio, en 2020, 14 y en 2021, 18. A nivel nacional, tres
          son las universidades que están entre las quinientas mejores del
          mundo: la Católica (135), la U. de Chile (183) y la U. de Santiago
          (487).
        </p>

        <p>
          Al revisar los resultados obtenidos en los diferentes indicadores, la
          Adolfo Ibáñez es la universidad que presenta el mayor porcentaje de
          profesores y alumnos internacionales. Mientras que el Top 10, según
          los empleadores al opinar sobre sus egresados, quedó conformado por la
          UC, de Chile, Adolfo Ibáñez, de Santiago, de Concepción, Técnica
          Federico Santa María, Diego Portales, Católica de Valparaíso, de los
          Andes y del Desarrollo.
        </p>

        <p>
          Se trata de los mismos planteles que, aunque en posiciones diferentes,
          lideran en prestigio de sus académicos.
        </p>
      </Columns>
      <QsWorldChilenos />
    </Content>
    <Summary />
  </Layout>
)

export default IndexPage
